// @flow

import React, { useContext } from 'react';
import { Environment } from '@ta/lithium.context';
import ResponsiveImage from './ResponsiveImage';
import type { Source } from './types';
import styles from './ResponsiveDefaultImage.css';

/** Props required for the ResponsiveDefaultImage component */
type Props = {|
  /** The default img url to display. Will be prefixed with the current cdn */
  url: string,
  /** Additional styling to add for this component. height 100% and width 100% by default */
  className?: string,
|};

const ResponsiveDefaultImage = ({ url, className }: Props) => {
  const { cdnPrefix } = useContext(Environment);

  // These widths and heights are arbitrary, since ResponsiveImage only has this
  // one image to choose from
  const defaultSource: Source = {
    url: `${cdnPrefix}${url}`,
    width: 200,
    height: 200,
  };

  return (
    <div className={className || styles.full}>
      <ResponsiveImage sources={[defaultSource]} width="100%" height="100%" />
    </div>
  );
};

export default ResponsiveDefaultImage;
